<template>
  <div class="rela">
    <transition name="fade">
      <div id="NECaptcha_login" class="NECaptcha" v-show="captcha_show"></div>
    </transition>
    <div class="changebtn">
      <div
        class="login-btn account-btn"
        :class="{'account-btn-active':loginType=='password'}"
        @click="loginType='password'"
      >
        <i></i>
        <span>{{$t('nav.w63')}}</span>
      </div>
      <div
        class="login-btn activelogin-btn"
        :class="{'activelogin-btn-active': loginType=='phone'}"
        @click="loginType='phone'"
      >
        <i></i>
        <span>{{$t('nav.w64')}}</span>
      </div>
    </div>

    <div v-show="loginType == 'password'" class="login_account">
      <Form label-position="top" ref="accountForm" :rules="accountFormRule" :model="accountForm">
        <FormItem :label="$t('label.w199')" prop="account">
          <Input :placeholder="$t('pl.p5')" v-model="accountForm.account"></Input>
        </FormItem>
        <FormItem :label="$t('label.w200')" prop="password">
          <Input :placeholder="$t('pl.p6')" type="password" v-model="accountForm.password"></Input>
        </FormItem>
        <div class="forgetpsd">
          <i></i>
          <router-link :to="{name:'forgetpwd'}">{{$t('nav.w65')}}</router-link>
        </div>
        <FormItem>
          <Button
            type="primary"
            class="clicknext"
            long
            :disabled="!accountForm.account || !accountForm.password"
            @click="submitValid"
          >{{$t('btn.b10')}}</Button>
        </FormItem>
      </Form>
    </div>

    <div v-show="loginType == 'phone'" class="login_account">
      <Form label-position="top" :model="phoneLgForm" ref="phoneLgForm" :rules="phoneLgFormRule">
        <FormItem :label="$t('label.w40')" prop="phone">
          <Input
            :placeholder="$t('pl.p7')"
            v-model="phoneLgForm.phone"
            name="phone"
            @on-change="inputChange"
          />
        </FormItem>
        <FormItem :label="$t('label.w35')" prop="code">
          <Row type="flex" :gutter="10">
            <Col span="15">
              <Input :placeholder="$t('pl.p8')" v-model="phoneLgForm.code" />
            </Col>
            <Col span="9">
              <Codebtn type="logPhone" :to="phoneLgForm.phone" :btndisabled="btndisabled" />
            </Col>
          </Row>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            class="clicknext"
            long
            :disabled="!phoneLgForm.phone || !phoneLgForm.code"
            @click="submitValid"
          >{{$t('btn.b10')}}</Button>
        </FormItem>
      </Form>
    </div>
    <div class="loginlink">
      <span>{{$t('msg.m8')}}</span>
      <router-link :to="{name:'register'}">{{$t('nav.w66')}}</router-link>
    </div>
  </div>
</template>

<script>
import formRule from "../../libs/formRule";
import Codebtn from "@/components/sendBtn";
import { post } from "../../libs/axios";
import Rsa from "@/libs/Rsa";
// import ydinit from "@/libs/ydinit";
import Exp from "@/libs/Exp";
export default {
  components: { Codebtn },
  data() {
    return {
      loginType: "password",
      btndisabled: true,
      NECaptchaValidate: "",
      captcha_show: false,
      captchaIns: null, //易盾实例
      accountForm: {
        account: "",
        password: ""
      },
      phoneLgForm: {
        phone: "",
        code: ""
      },
      accountFormRule: {
        account: formRule.logAccount,
        password: formRule.logPwd
      },
      phoneLgFormRule: {
        phone: [
          { required: true, message: this.$t("msg.m26"), trigger: "submit" },
          {
            validator: (rule, value, callback) => {
              if (!Exp.cnPhone.test(value) && !Exp.hkPhone.test(value)) {
                return callback(new Error(this.$t("msg.m28")));
              }
              callback();
            },
            trigger: "submit"
          }
        ],
        code: formRule.code
      }
    };
  },
  methods: {
    inputChange(e) {
      let { name, value } = e.target;
      if (name === "phone") {
        let re = !Exp.cnPhone.test(value) && !Exp.hkPhone.test(value);
        this.$nextTick(() => {
          this.btndisabled = re;
        });
      }
    },
    async submitValid() {
      let loginType = this.loginType;
      // 提交前验证表单
      let valid = await this.$refs[
        loginType == "password" ? "accountForm" : "phoneLgForm"
      ].validate();
      if (!valid) return;
      if (loginType == "password") {
        this.$axios
          .post("/Member/RZJAuth/PasswordLogin", {
            account: this.accountForm.account,
            passWord: Rsa(this.accountForm.password)
          })
          .then(res => {
            if (res.err == 0) {
              this.$store.dispatch("user/getUser", "all");
              this.$store.commit("user/logidValid", true);
            } else {
              return res.throw();
            }
          });
        // this.$axios
        //   .get("/Member/RZJAuth/UserIsLoginVerif", {
        //     params: { account: this.accountForm.account }
        //   })
        //   .then(res => {
        //     console.log(res);
        //     if (res.err == 0) {
        //       this.captcha_show = false;
        //       this.$axios
        //         .post("/Member/RZJAuth/PasswordLogin", {
        //           account: this.accountForm.account,
        //           passWord: Rsa(this.accountForm.password)
        //         })
        //         .then(res => {
        //           if (res.err == 0) {
        //             this.$store.dispatch("user/getUser", "all");
        //             this.$store.commit("user/logidValid", true);
        //           } else {
        //             return res.throw();
        //           }
        //         });
        //     }
        //     if (res.err == 400) {
        //       return res.throw();
        //     }
        //     if (res == true) {
        //       if (this.captchaIns) {
        //         this.captcha_show = true;
        //       } else {
        //         this.ydinit();
        //       }
        //     }
        //   });
      } else if (this.loginType == "phone") {
        this.submit();
      }
    },
    async submit() {
      let pm;
      if (this.loginType == "password") {
        pm = post("/Member/RZJAuth/PasswordLogin", {
          account: this.accountForm.account,
          passWord: Rsa(this.accountForm.password)
          // NECaptchaValidate: this.NECaptchaValidate
        });
      } else if (this.loginType == "phone") {
        pm = post("/Member/RZJAuth/DynamicLogin", {
          mobliePhone: this.phoneLgForm.phone,
          code: this.phoneLgForm.code
        });
      }
      pm.then(res => {
        console.log(res);
        if (res.err) {
          res.throw();
          // this.captcha_show = false;
          // this.captchaIns.refresh();
        }
        if (res.err == 0) {
          this.$store.dispatch("user/getUser", "all");
          this.$store.commit("user/logidValid", true);
        }
      });
    },
    // 易盾验证码初始化
    ydinit() {
      ydinit({
        element: "#NECaptcha_login",
        onVerify: (err, data) => {
          if (err) return;
          this.captcha_show = false;
          this.NECaptchaValidate = data.validate;
          this.submit();
        },
        onReady: instance => {
          this.captchaIns = instance;
          this.captcha_show = true;
        }
      });
    },
    go() {
      let back = this.$route.query.back;
      if (back && back != "/login") {
        this.$router.push(back);
      } else {
        this.$router.push({ name: "assets" });
      }
    }
  },
  computed: {
    logstate() {
      return this.$store.state.user.logstate;
    }
  },
  watch: {
    loginType() {
      this.captcha_show = false;
      this.$refs.accountForm.resetFields();
      this.$refs.phoneLgForm.resetFields();
    },
    logstate(v) {
      if (v) this.go();
    }
  },
  mounted() {
    if (this.logstate === true) this.go();
  },
  destroyed() {
    if (this.captchaIns) this.captchaIns.destroy();
  }
};
</script>

<style lang="less" scoped>
.changebtn {
  display: flex;
  cursor: pointer;
  width: 250px;
  height: 32px;
  background: rgba(228, 235, 248, 1);
  border-radius: 16px;
  margin: 0 auto 35px;
  .login-btn {
    width: 122px;
    height: 28px;
    margin-top: 2px;
    margin-left: 2px;
    border-radius: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      width: 14px;
      height: 14px;
      display: inline-block;
      margin-right: 8px;
      background: url("../../assets/login_icon14x14.png") no-repeat;
      background-size: cover;
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #65718a;
    }
  }
  .account-btn {
    i {
      background-position: 0 -14px;
    }
    span {
      margin-top: -2px;
    }
  }
  .activelogin-btn {
    i {
      background-position: 0 -42px;
    }
  }
  .account-btn-active {
    background: #fff;
    i {
      background-position: 0 0;
    }
    span {
      color: #232325;
    }
  }
  .activelogin-btn-active {
    background: #fff;
    i {
      background-position: 0 -28px;
    }
    span {
      color: #232325;
    }
  }
}
.login_account {
  width: 300px;
}
.mar-t20 {
  margin-top: 20px;
}
.forgetpsd {
  position: absolute;
  margin-top: -10px;
  width: 300px;
  height: 18px;
  color: #5e8ffc;
  font-weight: 400;
  display: flex;
  justify-content: flex-end;
  i {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    display: inline-block;
    background: url("../../assets/login_icon14x14.png") no-repeat;
    background-size: 14px;
    background-position: 0 -112px;
  }
  a {
    height: 18px;
    line-height: 18px;
    display: inline-block;
  }
}

.clicknext {
  margin-top: 50px;
}

.loginlink {
  margin-top: 30px;
  font-size: 14px;
  text-align: center;
  color: #7b7b7c;
  a {
    color: #5e8ffc;
    font-weight: 500;
  }
}
.rela {
  position: relative;
}
.NECaptcha {
  position: absolute;
  bottom: 115px;
  left: 0px;
  z-index: 9999;
  width: 300px;
  background: #fff;
}
</style>


